import core, { App, Poller } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { useMount, usePureSelector, useWithLocation } from 'hooks';
import matchList from 'modules/match-list';
import { getTimeIntervalByUnit } from 'utils';

const {
    utils: { getAppliedFilters, extendSearchString },
} = core;
const {
    actions: { searchMatches },
    selectors: { selectFetchStatus },
    pagination: {
        selectors: { selectIsPollingTurnedOff },
    },
} = matchList;

const POLLER_NAME = App.PollerName.Results;

interface Output {
    fetchStatus: App.FetchStatus;
    pollerOpts: Poller.UsePollerInput<typeof searchMatches>;
}

export default function useResult(): Output {
    const { location, dateFrom } = useWithLocation(l => ({
        location: l,
        dateFrom: !!getAppliedFilters().dateFrom,
    }));

    useMount(() => {
        if (dateFrom) return;

        extendSearchString(
            'dateFrom',
            getTimeIntervalByUnit({
                interval: -72,
                unit: 'hour',
            })
        );
    });

    const { fetchStatus, isPollingTurnedOff } = usePureSelector(s =>
        selectProps(s, { location })
    ); // NOTE: selectFetchStatus need of location

    return {
        fetchStatus,
        pollerOpts: {
            pollerName: POLLER_NAME,
            executableAction: searchMatches,
            isPollingTurnedOff,
            skipInitialRequest: !dateFrom,
        },
    };
}

const selectProps = createStructuredSelector({
    fetchStatus: selectFetchStatus,
    isPollingTurnedOff: selectIsPollingTurnedOff,
});
